import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Paper,
  Typography,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as routes from '../../config/routes';
import * as constants from '../../config/constants';


const albumItem = (props) => {
  const classNames = [classes.card, classes.cardFancy];
  const src = constants.BASE_URL + props.thumbnail;
  return (
    <Link
      className={classes.linkDeCSS}
      to={formatRoute(routes.GALLERY_DETAIL, { slug: props.slug })}
    >
      <Paper className={classNames.join(' ')} style={{ marginBottom: '10px' }} align="left">
        <img src={src} alt={props.slug} style={{ width: '100%', height: 'auto' }} />
        <br />
        <Typography variant="title">{props.title}</Typography>
      </Paper>
    </Link>
  );
};

export default albumItem;



// WEBPACK FOOTER //
// ./src/main/components/AlbumListItem.js